module.exports = __webpack_public_path__ + "img/company_kv_sp.8e3ae025.jpg";